import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { BookingService } from '../booking/booking.service';
import { RegUnit } from '../booking/_model/regional-unit.interface';

@Component({
    selector: 'bg-homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss'],
})
export class HomepageComponent implements OnInit, OnDestroy {
    pageTitle = environment.config.homepageTitle;
    links = environment.config.links;

    regUnits: RegUnit[];
    selectedRegUnit = new UntypedFormControl(null);

    constructor(private route: ActivatedRoute, private bookingService: BookingService) {}

    async ngOnInit() {
        this.regUnits = this.route.snapshot.data?.regUnits;

        let f = this.regUnits.find((r) => r.uid === this.bookingService.selectedRegUnit?.uid);
        if (f) this.selectedRegUnit.setValue(f);
    }

    ngOnDestroy(): void {}
}
